import { BRAND_PAGE_SAMPLE_REQUEST_MODAL_TYPE } from "@faire/retailer-shared/search/BrandPageQueryObj";
import { IUser } from "@faire/web-api/indigofair/data/IUser";
import brandPortal from "@faire/web-api/routes/brand-portal";
import {
  path as brandPagePath,
  QueryParameters as BrandPageQueryParameters,
} from "@faire/web-api/routes/brand/brandToken";
import videoPage from "@faire/web-api/routes/video/videoToken";
import { getLocationOrThrow } from "@faire/web/common/globals/getLocation";
import { FAIRE_DIRECT_BRAND_QUERY_PARAM } from "@faire/web/common/routes/faire-direct/FAIRE_DIRECT_BRAND_QUERY_PARAM";
import { Location } from "history";
import mapValues from "lodash/mapValues";
import qs from "query-string";

import { SAMPLE_PROSPECTING_SIGN_IN_QUERY_PARAM_VALUE } from "@faire/retailer/components/App/AppModals/consts";
import { RefusedRedirectToExternalUrl } from "@faire/retailer/events";
import { stringOrUndefined } from "@faire/retailer/lib/stringOrUndefined";
import { home } from "@faire/retailer/paths";
import { ProductPagePaths } from "@faire/retailer/paths/ProductPage";
import { getFaireBaseUrl } from "@faire/retailer/serialized-data/getFaireBaseUrl";
import { ElevatePortalStore } from "@faire/retailer/stores/domain/ElevatePortalStore";

export const redirectAfterSignIn = (location: Location, user: IUser) => {
  const currentPath = location.pathname;
  const currentQueryParams = mapValues(
    qs.parse(location.search),
    stringOrUndefined
  );

  // clear out any unneeded query params
  const queryParams = qs.stringify({
    ...currentQueryParams,
    signIn: undefined,
    signUp: undefined,
    signInTitle: undefined,
    signInText: undefined,
    brand: undefined,
    product: undefined,
    video: undefined,
    ifrp: undefined,
    oeln: undefined,
    oet: undefined,
    email: undefined,
    resetEmail: undefined,
    quickLogin: undefined,
    redirectTo: undefined,
    faireMarket: undefined,
  });
  if (currentQueryParams.redirectTo) {
    redirectToUrl(currentQueryParams.redirectTo);
  } else if (user.type === IUser.Type.BRAND_USER) {
    const queryParamsWithPrefix = queryParams ? `?${queryParams}` : "";
    getLocationOrThrow().replace(`${brandPortal()}${queryParamsWithPrefix}`);
  } else if (user.is_employee) {
    getLocationOrThrow().replace(`/admin2`);
  } else if (
    currentQueryParams.signIn === "product" &&
    currentQueryParams.product
  ) {
    const productPageOptions = {
      ...(ElevatePortalStore.get().active
        ? {
            [FAIRE_DIRECT_BRAND_QUERY_PARAM]:
              ElevatePortalStore.get().faireDirectAlias,
          }
        : {}),
    };
    getLocationOrThrow().replace(
      ProductPagePaths.index(currentQueryParams.product, productPageOptions)
    );
  } else if (currentQueryParams.video) {
    getLocationOrThrow().replace(videoPage(currentQueryParams.video));
  } else if (ElevatePortalStore.get().active) {
    const brandPageOptions: BrandPageQueryParameters =
      BrandPageQueryParameters.build({
        [FAIRE_DIRECT_BRAND_QUERY_PARAM]:
          ElevatePortalStore.get().faireDirectAlias,
      });
    if (
      currentQueryParams.signIn ===
        SAMPLE_PROSPECTING_SIGN_IN_QUERY_PARAM_VALUE &&
      currentQueryParams.sampleInvite
    ) {
      brandPageOptions.modalType = BRAND_PAGE_SAMPLE_REQUEST_MODAL_TYPE;
      brandPageOptions.sampleInvite = currentQueryParams.sampleInvite;
    }
    getLocationOrThrow().replace(
      brandPagePath(
        ElevatePortalStore.get().elevateBrandToken,
        brandPageOptions
      )
    );
  } else {
    const pathAndQueryParams = `${currentPath}${
      queryParams ? `?${queryParams}` : ""
    }`;
    getLocationOrThrow().replace(pathAndQueryParams);
  }
};

const redirectToUrl = (url: string) => {
  if (isValidFaireUrl(url)) {
    getLocationOrThrow().replace(url);
  } else {
    RefusedRedirectToExternalUrl.publish(url);
    getLocationOrThrow().replace(home());
  }
};

const isValidFaireUrl = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url, getLocationOrThrow().href);

    // Because Faire can be served on subdomains (subdomain.faire.com),
    //  we need to take the last 2 segments of the host name (faire.com)
    //  and check if its valid.
    const hostnameSegments = parsedUrl.hostname.split(".");
    const domainSuffix = hostnameSegments
      .slice(Math.max(hostnameSegments.length - 2, 0))
      .join(".");
    const validHost = getFaireBaseUrl();

    if (domainSuffix === "faire.team") {
      return true;
    }

    return domainSuffix === validHost;
  } catch {
    return false;
  }
};
